import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAccount } from 'wagmi';

import { getMarketCurrencies, getMarketInstruments, getMarketPrices } from 'store/entities/market/thunks';
import { getConfig } from 'store/entities/web3Config/thunks';
import { isMainnet } from 'utils';

import MainCreateOrder from 'components/mainCreateOrder';
import MainMarketInfo from 'components/mainMarketInfo/MainMarketInfo';
import MainViewOrders from 'components/mainViewOrders';
import Modal from 'components/welcomeModal';
import WelcomeModalContent from 'components/welcomeModalContent';

import './Home.scss';

const Home = () => {
  const dispatch = useDispatch();
  const { isConnected } = useAccount();

  const [isModal, setIsModal] = useState(true);

  useEffect(() => {
    dispatch(getMarketCurrencies());
    dispatch(getMarketInstruments());
    dispatch(getMarketPrices());
    dispatch(getConfig());
  }, [dispatch]);

  return (
    <div className="container main">
      <section className="main-coll-1">
        <MainCreateOrder />
        <MainMarketInfo />
      </section>
      <section className="main-coll-2">
        <MainViewOrders />
      </section>

      {isModal && !isConnected && (
        <Modal handlerClose={() => setIsModal(false)}>
          <WelcomeModalContent isMainnet={isMainnet()} />
        </Modal>
      )}
    </div>
  );
};

export default Home;
